<header class="customer-navbar">
  <div class="navbar-inner" [class.has-cart]="showCart">
    <a class="nav-brand" routerLink="/welcome" aria-label="Onticket, inicio" (click)="sidenavMenu.close()">onticket</a>
    <nav class="desktop-navigation" aria-label="Navegación principal">
      <a routerLink="/events" routerLinkActive="nav-active" #activeLink1="routerLinkActive" [attr.aria-current]="activeLink1.isActive ? 'page' : null">Eventos</a>
      <a routerLink="/menus" routerLinkActive="nav-active" #activeLink2="routerLinkActive" [attr.aria-current]="activeLink2.isActive ? 'page' : null">Barra</a>
      <a routerLink="/business" routerLinkActive="nav-active" #activeLink3="routerLinkActive" [attr.aria-current]="activeLink3.isActive ? 'page' : null">Organiza un evento</a>
    </nav>
    <div class="navbar-actions">
      <a class="nav-tickets" routerLink="/tickets-access" routerLinkActive="nav-active"
        #activeLink4="routerLinkActive" [attr.aria-current]="activeLink4.isActive ? 'page' : null" aria-label="Mis entradas" (click)="sidenavMenu.close()">
        <mat-icon aria-hidden="true">confirmation_number</mat-icon><span>Mis entradas</span>
      </a>
      <button class="nav-login" *ngIf="!authService.getUser().uid" type="button" (click)="login()">Ingresar</button>
      <button class="nav-cart" *ngIf="showCart" type="button" (click)="toggleCart()"
        [attr.aria-label]="'Abrir carrito, ' + quantityProduct + (quantityProduct === 1 ? ' producto' : ' productos')">
        <mat-icon aria-hidden="true">shopping_bag</mat-icon>
        <span class="cart-count" *ngIf="quantityProduct">{{ quantityProduct }}</span>
      </button>
      <button class="menu-toggle" type="button" (click)="toggleMenu()"
        [class.is-open]="sidenavMenu.opened" [attr.aria-expanded]="sidenavMenu.opened"
        aria-controls="customer-navigation" [attr.aria-label]="sidenavMenu.opened ? 'Cerrar menú' : 'Abrir menú'">
        <span aria-hidden="true"></span><span aria-hidden="true"></span>
      </button>
    </div>
  </div>
</header>
